import type { ReactNode } from 'react';
import { PortalThemeProvider, type ThemeProviderProps } from './ThemeProvider';
import { AuthProvider } from '@aliza/auth';
import { AnalyticsProvider } from '@aliza/analytics';

export interface AppProvidersProps {
  children: ReactNode;
  themeProps?: Omit<ThemeProviderProps, 'children'>;
}

export function AppProviders({ children, themeProps }: AppProvidersProps) {
  return (
    <PortalThemeProvider {...themeProps}>
      <AuthProvider>
        <AnalyticsProvider>
          {children}
        </AnalyticsProvider>
      </AuthProvider>
    </PortalThemeProvider>
  );
}
